var locale = {
    'NO_SITES': 'No records',
}
export default locale;